module.exports = __webpack_public_path__ + "static/jose_ruivo-ac335f24b8fd5b4f30e2d21e94075dfa.png";